// chc-admin-web 의 report-pdf 용 const 를 그대로 이식한 파일.
// 꺾은선(PDF) 리포트에서 graphCd(CHI_*) 로 등급 점선/커스텀 y축을 잡는다.
// (화면용 youngAdultLegendList 와는 형태가 달라 별도 파일로 유지)

export interface IPdfLegendItem {
  label: string;
  value: number;
  color: string;
}

export interface IPdfLegendInfo {
  legendList: IPdfLegendItem[];
  yAxis: number[];
  maxValue: number;
  isBelowBad?: boolean;
}

const redColor = '#F24D4D';
const orangeColor = '#FFB800';
const greenColor = '#40A640';

const getPDFLegendList = ({ low, middle, high, isReverse = false }: { low: number; middle?: number; high: number; isReverse?: boolean }): IPdfLegendItem[] => {
  return [
    { label: isReverse ? '심각' : '우수', value: low, color: greenColor },
    ...(typeof middle === 'undefined' ? [] : [{ label: '보통', value: middle, color: orangeColor }]),
    { label: isReverse ? '우수' : '심각', value: high, color: redColor },
  ];
};

const qolCase: IPdfLegendInfo = {
  legendList: getPDFLegendList({ low: 100, middle: 66, high: 33 }),
  yAxis: [0, 20, 40, 60, 80, 100, 120],
  maxValue: 120,
};

// report-pdf(꺾은선)용: graphCd(CHI_*) 로 키를 잡은 버전
export const youngAdultLegendInfoByCode: { [key: string]: IPdfLegendInfo } = {
  CHI_B_11: {
    legendList: [{ label: '우수', value: 600, color: '#000000' }],
    yAxis: [0, 200, 400, 600, 800, 1000],
    maxValue: 1000,
    isBelowBad: true,
  }, // 신체활동
  CHI_B_12: {
    legendList: getPDFLegendList({ low: 2, middle: 5, high: 8 }),
    yAxis: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    maxValue: 9,
  }, // 음주력
  CHI_B_13: {
    legendList: getPDFLegendList({ low: 1, middle: 2, high: 3 }),
    yAxis: [0, 1, 2, 3, 4],
    maxValue: 4,
  }, // 흡연 (step)
  CHI_M_10: {
    legendList: getPDFLegendList({ low: 1, middle: 2, high: 3 }),
    yAxis: [0, 1, 2, 3, 4],
    maxValue: 4,
  }, // 스트레스 (step)
  CHI_M_11: {
    legendList: getPDFLegendList({ low: 4, middle: 14, high: 27 }),
    yAxis: [0, 5, 10, 15, 20, 25, 30],
    maxValue: 30,
  }, // 우울감 5단계
  CHI_M_12: {
    legendList: getPDFLegendList({ low: 4, middle: 14, high: 21, isReverse: true }),
    yAxis: [0, 5, 10, 15, 20, 25],
    maxValue: 25,
  }, // 불안감
  CHI_M_13: {
    legendList: getPDFLegendList({ low: 18.5, middle: 23, high: 25 }),
    yAxis: [15, 20, 25, 30, 35, 40],
    maxValue: 40,
    isBelowBad: true,
  }, // BMI 6단계
  CHI_M_14: {
    legendList: [
      { label: '심각', value: 17, color: redColor },
      { label: '우수', value: 25, color: greenColor },
    ],
    yAxis: [0, 5, 10, 15, 20, 25, 30],
    maxValue: 30,
  }, // 목표지향_새로운가능성
  CHI_M_15: {
    legendList: [
      { label: '심각', value: 14, color: redColor },
      { label: '우수', value: 20, color: greenColor },
    ],
    yAxis: [0, 5, 10, 15, 20, 25],
    maxValue: 25,
  }, // 목표지향_내적역량강화
  CHI_S_11: {
    legendList: getPDFLegendList({ low: 100, middle: 66, high: 33 }),
    yAxis: [0, 20, 40, 60, 80, 100, 120],
    maxValue: 120,
  }, // 사회적지지
  CHI_S_12: {
    legendList: getPDFLegendList({ low: 1, middle: 2, high: 3 }),
    yAxis: [0, 1, 2, 3, 4],
    maxValue: 4,
  }, // 스마트폰 (step)
  CHI_C_11: qolCase, // 삶의질_신체기능
  CHI_C_12: qolCase, // 삶의질_신체적역할제한
  CHI_C_13: qolCase, // 삶의질_감정적역할제한
  CHI_C_14: qolCase, // 삶의질_사회적기능
  CHI_C_15: qolCase, // 삶의질_신체통증
  CHI_C_16: qolCase, // 삶의질_전반적건강
  CHI_C_17: qolCase, // 삶의질_활력
  CHI_C_18: qolCase, // 삶의질_정신건강
  CHI_C_19: qolCase, // 삶의질_건강변화
};
